import { api } from "api";

export const getInvoices = (month, year, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/invoice/get-invoice/${month}/${year}`)
      .then((res) => {
        dispatch({
          type: "GET_INVOICES_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_INVOICES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const exportInvoice = (month, year, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/invoice/export-invoice/${month}/${year}`)
      .then((res) => {
        const fileName = res.headers["content-disposition"].split(';')[1].split('=')[1];
        onSuccess(res, fileName);
      })
      .catch((e) => {
        dispatch({
          type: "EXPORT_INVOICES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};



export const getapplicantInvoices = (month, year, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/invoice/get-invoice-applicant/${month}/${year}`)
      .then((res) => {
        dispatch({
          type: "GET_INVOICES_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_INVOICES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const exportapplicantInvoice = (month, year, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/invoice/export-invoice-applicant/${month}/${year}`)
      .then((res) => {
        const fileName = res.headers["content-disposition"].split(';')[1].split('=')[1];
        onSuccess(res, fileName);
      })
      .catch((e) => {
        dispatch({
          type: "EXPORT_INVOICES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};







export const getemployeeInvoices = (month, year, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/invoice/get-invoice-employee/${month}/${year}`)
      .then((res) => {
        dispatch({
          type: "GET_INVOICES_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_INVOICES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const exportemployeeInvoice = (month, year, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/invoice/export-invoice-employee/${month}/${year}`)
      .then((res) => {
        const fileName = res.headers["content-disposition"].split(';')[1].split('=')[1];
        onSuccess(res, fileName);
      })
      .catch((e) => {
        dispatch({
          type: "EXPORT_INVOICES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};